var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65625 2.3125L11.4375 5.90625C11.7188 6.46875 12.4688 6.625 12.9375 6.25L15.75 4C15.5938 3.8125 15.5 3.53125 15.5 3.25C15.5 2.5625 16.0312 2 16.75 2C17.4375 2 18 2.5625 18 3.25C18 3.96875 17.4375 4.5 16.75 4.5C16.7188 4.5 16.7188 4.5 16.7188 4.5L15.2812 12.375C15.125 13.3125 14.2812 14 13.3125 14H4.65625C3.6875 14 2.84375 13.3125 2.6875 12.375L1.25 4.5C0.53125 4.5 0 3.96875 0 3.25C0 2.5625 0.53125 2 1.25 2C1.9375 2 2.5 2.5625 2.5 3.25C2.5 3.53125 2.40625 3.8125 2.25 4L5.03125 6.25C5.53125 6.625 6.25 6.46875 6.53125 5.90625L8.34375 2.3125C7.96875 2.09375 7.75 1.71875 7.75 1.25C7.75 0.5625 8.28125 0 9 0C9.6875 0 10.25 0.5625 10.25 1.25C10.25 1.71875 10 2.09375 9.65625 2.3125ZM3.65625 12.1875C3.75 12.6562 4.15625 13 4.65625 13H13.3125C13.8125 13 14.2188 12.6562 14.3125 12.1875L15.5312 5.46875L13.5625 7.03125C12.5938 7.8125 11.0938 7.5 10.5312 6.34375L9 3.25L7.4375 6.34375C6.875 7.5 5.375 7.8125 4.40625 7.03125L2.4375 5.46875L3.65625 12.1875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.9b62fdde3848edb74be0ff188fd6a3de.svg";
export { ForwardRef as ReactComponent };